import { render } from "./FoodList.vue?vue&type=template&id=452dac00"
import script from "./FoodList.vue?vue&type=script&lang=js"
export * from "./FoodList.vue?vue&type=script&lang=js"

import exportComponent from "L:\\Web\\htdocs\\Testroom\\gruene-mitte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__